<li :class="{ 'layout-root-menuitem': root, 'active-menuitem': isActiveMenu }">
    <div v-if="root && item.visible !== false" class="layout-menuitem-root-text">{{ item.label }}</div>
    <!----------------------------------------------------------------------------------------------------------->
    <!----------------------------------------------------------------------------------------------------------->
    <a v-if="(!item.to || item.items) && item.visible !== false" :href="item.url" @click="itemClick($event, item, index)" :class="item.class" :target="item.target" tabindex="0">
        <font-awesome-icon 
            v-if="Array.isArray(item.icon) && item.icon.length === 2 && item.icon.every(i => typeof i === 'string' && i.trim() !== '')" 
            :icon="item.icon" 
            class="layout-menuitem-icon" 
        />
        <span class="layout-menuitem-text">{{ item.label }}</span>
        <font-awesome-icon :icon="['fas', 'chevron-down']" class="layout-submenu-toggler" v-if="item.items"/>
    </a>
    <!----------------------------------------------------------------------------------------------------------->
    <router-link v-if="item.to && !item.items && item.visible !== false" @click="itemClick($event, item, index)" :class="[item.class, { 'active-route': checkActiveRoute(item) }]" tabindex="0" :to="item.to">
        <font-awesome-icon 
            v-if="Array.isArray(item.icon) && item.icon.length === 2 && item.icon.every(i => typeof i === 'string' && i.trim() !== '')" 
            :icon="item.icon" 
            class="layout-menuitem-icon" 
        />
        <span class="layout-menuitem-text">{{ item.label }}</span>
        <font-awesome-icon :icon="['fas', 'chevron-down']" class="layout-submenu-toggler" v-if="item.items"/>
    </router-link>
    <!----------------------------------------------------------------------------------------------------------->
    <Transition v-if="item.items && item.visible !== false" name="layout-submenu">
        <ul v-show="root ? true : isActiveMenu" class="layout-submenu">
            <app-sidebar-menu-item v-for="(child, i) in item.items" :key="child" :index="i" :item="child" :parentItemKey="itemKey" :root="false"></app-sidebar-menu-item>
        </ul>
    </Transition>
</li>



